import Analytics from 'shared_modules/Analytics';

const events = {
  SEARCHING_FOR_PRINTERS: 'Searching for printers',
  VISITED_TROUBLESHOOT: 'Visited troubleshooting link',
  VISITED_SSL: 'Visited SSL exception link',
  VISITED_HELP: 'Visited help link',
  OPENED_STARTUP: 'Opened BrowserPrint Startup',
  CLOSED_WITHOUT_PRINTING: 'Closed without printing',
  CLOSED_AFTER_DOWNLOADING: 'Closed after downloading',
  CLOSED_WITHOUT_DOWNLOADING: 'Closed without downloading',
  DOWNLOADED_INSTALLER: 'Downloaded the installer',
  CHANGED_PRINTER: 'Changed Printer',
  CHANGED_LABEL: 'Changed Label Size',
  OPENED_PRINT: 'Opened print job',
  UPDATED_COPIES: 'Updated number of copies',
  PRINTED_SUCCESSFULLY: 'Printed successfully',
  FAILED_PRINTING: 'Failed Printing',
  APPLICATION_CLOSED: 'Application closed / crashed',
  ADJUSTED_MARGIN: 'Adjusted margin',
};

/**
 * Class LabelPrintTracking handles the event tracking through Mixpanel
 */
export default class LabelPrintTracking {
  static get events() {
    return events;
  }

  /**
   * Send tracking event to Mixpanel
   * @param {String} event - Event string to be sent
   * @param {Object} [data] - Optional data to send
   */
  static track(event, data) {
    // eslint-disable-next-line no-param-reassign
    event = LabelPrintTracking.events[event] || event;

    // Log Analytics events on dev, expand this to the main Analytics class?
    if (~['localhost', 'rad.localdev'].indexOf(window.location.hostname)) {
      // eslint-disable-next-line no-console
      console.log(
        `%c BrowserPrint - ${event}${data ? ` - ${JSON.stringify(data)}` : ''}`,
        'background: #e9fafe; color: #2875c6'
      );
    }
    Analytics.track(`BrowserPrint - ${event}`, data);
  }
}
